import { Title } from '@bpm-web-app/components';
import { Midi } from '@bpm-web-app/components/pages';
import { Banner } from '@bpm-web-app/components/src/lib/shared';

export default function midiPage({ title }: { title: string }) {
    return (
        <>
            <Title platform="create" title={title} />
            <Banner platform="create" location="midi" variant="hidden" />
            <Midi />
        </>
    );
}

export async function getStaticProps() {
    return {
        props: {
            title: 'MIDI'
        }
    };
}
